import React, { useEffect, useState } from 'react';
import InputItem from '../../../../component/inputItem';
import { MainButton } from '../../../../component/button';
import { useMobile } from '../../../../hook/usePlatform';
import { lineColor } from '../../../../util/colors';
import { login } from '../../../../api/authAPI';
import PasswordChangeCompleteModal from './passwordChangeCompleteModal';
import useAuth from '../../../../hook/useAuth';

const PasswordChangeInput:React.FC = () => {
  const [prePassword, setPrePassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const isMobile = useMobile();
  const border = isMobile ? '' : `solid 1px ${lineColor}`;
  const [showResultModal, setShowResultModal] = useState(false);
  const { changePassword } = useAuth();
  const onChangePassword = async () => {
    try {
      if (passwordConfirm !== newPassword) {
        setError('비밀번호가 다릅니다.');
        return;
      }
      await changePassword(prePassword, newPassword);
      setShowResultModal(true);
    } catch (e) {
      console.error(e);
      setError('비밀번호를 확인해주세요.');
    }
  };
  useEffect(() => {
    if (passwordConfirm.length > 0 && newPassword !== passwordConfirm) {
      setError('비밀번호가 다릅니다.');
    } else {
      setError(null);
    }
  }, [newPassword, passwordConfirm]);
  return (
    <div
      style={{
        borderTop: border,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBottom: isMobile ? 0 : 200,
      }}
    >
      <PasswordChangeCompleteModal visible={showResultModal} setVisible={setShowResultModal} />
      <div
        style={{
          width: isMobile ? '90%' : '30%',
          display: 'flex',
          flexDirection: 'column',
          gap: 30,
          paddingBlock: isMobile ? 32 : 54,
        }}
      >
        <InputItem
          title="이전 비밀번호"
          placeholder="이전 비밀번호를 입력해주세요"
          value={prePassword}
          type="password"
          setValue={setPrePassword}
          required
        />
        <InputItem
          title="새 비밀번호"
          placeholder="8~16자, 영문, 숫자, 특수문자 중 2개 조합"
          type="password"
          value={newPassword}
          setValue={setNewPassword}
          required
        />
        <InputItem
          title="비밀번호 확인"
          placeholder="비밀번호를 한 번 더 입력해주세요."
          type="password"
          value={passwordConfirm}
          setValue={setPasswordConfirm}
          errorText={error ?? ''}
          isError={error !== null}
          required
        />
        <MainButton
          text="확인"
          onPress={onChangePassword}
          style={{ width: '100%' }}
        />
      </div>
    </div>
  );
};

export default PasswordChangeInput;
